import { http } from './http'

//登录
export const login = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/login',
        method: 'post',
        body: data,
    })

// 注册
export const register = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/register-v2',
        method: 'post',
        body: data,
    })

// 获取验证码
export const getVerifyCode = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/register-verify-code',
        method: 'get',
        query: params,
    })
// 获取邀请码
export const getInviteCode = () =>
    http({
        // baseUrl: baseUrl,
        url: '/api/public/invite-code-url',
        method: 'get',
    })

// 获取验证码(绑定邮箱)
export const getBindEmailCode = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/send-email-code',
        method: 'post',
        body: data,
        // headers: {
        //     'x-token': token
        // }
    })

// 获取验证码（手机）
export const getPhoneVerifyCode = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/send-sms-code',
        method: 'post',
        body: data,
    })

// 重置手机 密码
export const resetPhonePassword = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/reset-password-by-phone',
        method: 'post',
        body: data,
    })

// 重置邮箱 密码
export const resetEmailPassword = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/reset-password-by-email',
        method: 'post',
        body: data,
    })
        
// 获取公司    
export const getCompany = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/search-companies',
        method: 'get',
        query: params,
    })

// 发送短信验证码
export const sendSmsCode = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/send-sms-code',
        method: 'post',
        body: params,
    })

// 手机号注册
export const registerByPhone = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/register-by-phone',
        method: 'post',
        body: params,
    })

// 手机号密码登录
export const loginByPhone = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/login-by-phone',
        method: 'post',
        body: params,
    })

// 绑定手机号
export const bindPhone = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/bind-phone',
        method: 'post',
        body: params,
    })

// 绑定邮箱
export const bindEmail = (params) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/bind-email',
        method: 'post',
        body: params,
    })
export const loginBindWx = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/login/qrcode/bind',
        method: 'post',
        body: data,
        // headers: {
        //     'x-token': token
        // }
    }) 
    
// 重置密码    
export const resetPassword = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/init-password',
        method: 'post',
        body: data,
    })

// 获取微信登录 二维码
export const postWxQrcode = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/login/qrcode/session',
        method: 'post',
        body: data,
    })
// 获取 微信登录 二维码 状态
export const postWxQrcodeStatus = (data) =>
    http({
        // baseUrl: baseUrl,
        url: '/api/user/login/qrcode/userinfo',
        method: 'post',
        body: data,
    })     